const PANEL_WIDTH = 280
const PANEL_HEIGHT = 320

function readPoint (point) {
  if (!point) return null
  const x = typeof point.x === 'number' ? point.x : (typeof point.getX === 'function' ? point.getX() : null)
  const y = typeof point.y === 'number' ? point.y : (typeof point.getY === 'function' ? point.getY() : null)
  if (!Number.isFinite(x) || !Number.isFinite(y)) return null
  return { x, y }
}

function toTopMapPoint (mapEl, topMapEl, point) {
  if (!mapEl || !topMapEl || !point) return null
  const mapRect = mapEl.getBoundingClientRect()
  const topRect = topMapEl.getBoundingClientRect()
  return {
    x: mapRect.left - topRect.left + point.x,
    y: mapRect.top - topRect.top + point.y,
  }
}

export function computePanelPosition (markerPoint, containerSize, panelSize = { width: PANEL_WIDTH, height: PANEL_HEIGHT }) {
  const cw = containerSize.width || 0
  const ch = containerSize.height || 0
  const pw = panelSize.width
  const ph = panelSize.height
  let left = markerPoint.x + 24
  let top = markerPoint.y - ph - 12
  if (top < 8) {
    top = markerPoint.y + 24
  }
  if (left + pw > cw - 8) {
    left = Math.max(8, cw - pw - 8)
  }
  if (left < 8) left = 8
  if (top + ph > ch - 8) {
    top = Math.max(8, ch - ph - 8)
  }
  return { left, top }
}

export function getFallbackPanelPosition (topMapEl) {
  if (!topMapEl) return { left: 16, top: 16 }
  const rect = topMapEl.getBoundingClientRect()
  return computePanelPosition(
    { x: rect.width - 320, y: rect.height / 2 },
    { width: rect.width, height: rect.height },
  )
}

export function getTiandituScreenPoint (mapTD, T, lng, lat, topMapEl) {
  if (!mapTD || !T || !topMapEl) return null
  const lngLat = new T.LngLat(lng, lat)
  let rawPoint = null
  if (typeof mapTD.lngLatToContainerPoint === 'function') {
    rawPoint = readPoint(mapTD.lngLatToContainerPoint(lngLat))
  } else if (typeof mapTD.lngLatToLayerPoint === 'function') {
    rawPoint = readPoint(mapTD.lngLatToLayerPoint(lngLat))
  }
  const mapEl = document.getElementById('mapDiv')
  return toTopMapPoint(mapEl, topMapEl, rawPoint)
}

export function getGoogleScreenPoint (map, lng, lat, topMapEl) {
  const google = window.google
  if (!map || !google?.maps || !topMapEl) {
    return Promise.resolve(null)
  }
  return new Promise((resolve) => {
    const overlay = new google.maps.OverlayView()
    overlay.onAdd = function onAdd () {
      const projection = overlay.getProjection()
      if (!projection) {
        overlay.setMap(null)
        resolve(null)
        return
      }
      const pixel = projection.fromLatLngToContainerPixel(new google.maps.LatLng(lat, lng))
      const rawPoint = readPoint(pixel)
      const mapEl = map.getDiv ? map.getDiv() : null
      overlay.setMap(null)
      resolve(toTopMapPoint(mapEl, topMapEl, rawPoint))
    }
    overlay.draw = function draw () {}
    overlay.setMap(map)
  })
}

export async function resolvePanelPosition ({
  mapType,
  lng,
  lat,
  topMapEl,
  mapTD,
  T,
  googleMap,
}) {
  if (!topMapEl) return { left: 16, top: 16 }
  const containerSize = {
    width: topMapEl.clientWidth,
    height: topMapEl.clientHeight,
  }
  let markerPoint = null
  if (mapType === 'tdt') {
    markerPoint = getTiandituScreenPoint(mapTD, T, lng, lat, topMapEl)
  } else if (googleMap) {
    markerPoint = await getGoogleScreenPoint(googleMap, lng, lat, topMapEl)
  }
  if (!markerPoint) {
    return getFallbackPanelPosition(topMapEl)
  }
  return computePanelPosition(markerPoint, containerSize)
}
